export default function ({ query, store, params, redirect, error }) {
  const isSubscriber = store.getters['user/isSubscriber']
  const isUser = store.getters['user/isLoggedIn']
  const userAnswers = store.state.quiz.answers

  if (isSubscriber) {
    return redirect('/my_account', query)
  } else if (isUser) {
    return redirect('/recommendations', query)
  }

  const questionNumber = Number(params.questionNumber)

  if (params.questionNumber && isNaN(questionNumber)) {
    error({ statusCode: 404 })
  }

  /**
   * If no question
   * If invalid question
   * If question number > 1 and no answers
   */
  if (
    !questionNumber ||
    questionNumber < 1 ||
    questionNumber > 13 ||
    (questionNumber > 1 && !Object.keys(userAnswers).length)
  ) {
    return redirect(`/${params.landing}/quiz/1`, query)
  }
}
